<app-header></app-header>
<div class='govpl-spacer'></div>
<main>
  <div>
    <section class='gov-services blue-bar-row blue-bar-row--epolak'>
      <div class='main-container'>
        <div class='blue-bar'>
          <div class='blue-bar-content'>
            <h2>Załatwiaj sprawy urzędowe</h2>
            <span class='subheader'>przez internet, bezpiecznie i wygodnie!</span>
            <form class='search-form' [formGroup]='form' (submit)='onSearch()' novalidate>
              <input formControlName='query' placeholder='Szukaj usług'
                     aria-label='Wpisz nazwę do wyszukania. Naciśnij TAB aby przejść do przycisku.'>
              <button type='submit'>
                <span class='sr-only'>Wyszukaj</span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
    <section class='gov-services'>
      <div class='main-container'>
        <div class='tabs-container'>
          <div>
            <ul id='services-tabs' role='tablist'>
              <li>
                <a #servicesTab id='services-tab' data-toggle='tab' href='#'
                   (click)="$event.preventDefault(); activeTab = servicesTab" role='tab'
                   aria-controls='services' aria-selected='true' [ngClass]="{ active: activeTab === servicesTab }">
                  Usługi
                </a>
              </li>
              <li>
                <a #budgetTab id='budget-tab' data-toggle='budget' href='#'
                   (click)="$event.preventDefault(); activeTab = budgetTab" role='tab'
                   aria-controls='budget' aria-selected='false' [ngClass]="{ active: activeTab === budgetTab }">
                  Budżet obywatelski
                </a>
              </li>
            </ul>
          </div>
        </div>
        <br>
        @if (activeTab === servicesTab) {
          <div id='services' class='tab-content' aria-labelledby='services-tab'>
            <ul>
              @for (item of services(); track $index) {
                @if (($index < 12) && !item.isCaseRelated) {
                  <li>
                    <a [routerLink]='"/e-uslugi" + item.url'>
                      <img aria-hidden="true" src='/img/icons/services/13-pismo-ogolne-do-urzedu.svg'
                           alt='Ikonka list do urzędu'>
                      <span>{{ item.name }}</span>
                    </a>
                  </li>
                }
              }
            </ul>
            <div class='center-buttons'>
              <a class='see-more-button btn btn-secondary d-flex align-items-center' routerLink='/e-uslugi'>
                Zobacz wszystkie usługi
              </a>
            </div>
          </div>
        }
        @if (activeTab === budgetTab) {
          <div id='budget' class='tab-content active' aria-labelledby='budgetTab-tab'>
            <ul>
              @for (item of civicBudgets(); track $index) {
                <li>
                  <a [routerLink]='"/budzet-obywatelski/" + item.id'>
                    <img aria-hidden="true" src='/img/icons/services/15-finansowanie.svg' alt='Ikonka finansowanie'>
                    <span>{{ item.name }}</span>
                  </a>
                </li>
              }
            </ul>
            <div class="center-buttons">
              <a class='see-more-button btn btn-secondary d-flex align-items-center' routerLink='/budzet-obywatelski'>
                Zobacz wszystkie
              </a>
            </div>
          </div>
        }
      </div>
    </section>
  </div>
</main>
<app-footer></app-footer>
